import React from 'react';
import type { FC } from 'react';
import classNames from 'clsx';

import { nameToInitials } from './utils';
import styles from './MemberInitials.module.scss';

export type MemberInitialsProps = {
  dataHook?: string;
  className?: string;
  name?: string;
};

export const MemberInitials: FC<MemberInitialsProps> = ({
  dataHook,
  className,
  name,
}) => {
  const hasName = !!name;
  const initials = nameToInitials(name);

  return (
    <div
      title={name}
      aria-label={name}
      data-hook={dataHook}
      className={classNames(styles.root, className, {
        [styles.textAvatar]: hasName,
        [styles.anonymousAvatar]: !hasName,
      })}
      data-initials={initials}
    ></div>
  );
};
